import { ImportPortefeuilleDetail } from "../../../models/ImportPortefeuilleDetail";
import { Component, Input, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-item-detail",
  templateUrl: "./item-detail.component.html",
  styleUrls: ["./item-detail.component.scss"],
})
export class ItemDetailComponent implements OnInit {
  @Input()
  portefeuilleDetail: ImportPortefeuilleDetail;
  @Input()
  importPortefeuilleId: number;

  constructor() {}

  ngOnInit() {}
}
